 import icon1 from '../../assets/images/home/icon_1.png'
 import icon2 from '../../assets/images/home/icon_2.png'
 import icon3 from '../../assets/images/home/icon_3.png'

 export const serviceBoxData = [
    {
        imgSrc:icon1,
        heading:'Last-Mile Delivery',
        content:'Fast, eco-conscious deliveries that bring your products straight to your customers\' doors.'
    },
    {
        imgSrc:icon2,
        heading:'Regional Freight',
        content:'Covering short to mid-range hauls with the efficiency of electric vehicles, lowering costs and emissions.'
    },
    {
        imgSrc:icon3,
        heading:'AI-Driven Logistics Optimization',
        content:'Smart scheduling, route planning, and battery management to enhance operational efficiency and reduce energy consumption.'
    }
]